import { useCallback, useEffect, useState } from "react";
import {
  Button,
  Row,
  Col,
  Container,
  FloatingLabel,
  FormControl,
} from "react-bootstrap";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import ApiService from "../../../services/api";

const MusicList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [music, setMusic] = useState([]);
  const [filtredMusic, setFiltredMusic] = useState([]);
  const [Loading, setLoading] = useState(true);

  const fetchMusicCompositions = async () => {
    const compositionsNews = await ApiService.getMusic();
    setMusic(compositionsNews.sort((a, b) => b.id - a.id));
    setLoading(false);
  };

  useEffect(() => {
    fetchMusicCompositions();
  }, []);

  useEffect(() => {
    const filtered = music.filter(
      (item) =>
        (!item.link &&
          "File audio e video"
            .toLowerCase()
            .includes(searchTerm.toLowerCase())) ||
        (item.link &&
          "Link esterno".toLowerCase().includes(searchTerm.toLowerCase())) ||
        (item.category.name &&
          item.category.name
            .toLowerCase()
            .includes(searchTerm.toLowerCase())) ||
        (item.title &&
          item.title.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (item.description &&
          item.description.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (item.description_eng &&
          item.description_eng.toLowerCase().includes(searchTerm.toLowerCase()))
    );
    setFiltredMusic(filtered);
  }, [searchTerm, music]);

  const handleSearchChange = (event) => {
    const term = event.target.value;
    setSearchTerm(term);
  };

  const deleteMusic = useCallback(
    async (slug) => {
      const confirmed = window.confirm(
        "Sei sicuro di voler eliminare questo contenuto?"
      );
      if (confirmed) {
        try {
          await ApiService.deleteMusic(slug);
          setMusic((prev) => prev.filter((item) => item.slug !== slug));
        } catch (e) {
          console.log("Errore durante l'eliminazione della musica");
        }
      }
    },
    [music]
  );

  const paginationOptions = {
    rowsPerPageText: "Elementi per pagina",
    rangeSeparatorText: "di",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Tutti",
  };

  const columns = [
    {
      name: "Categoria",
      selector: (row) => row.category.name,
      center: "true",
      width: "25%",
    },
    {
      name: "Titolo",
      selector: (row) => row.title,
      center: "true",
      width: "25%",
    },
    {
      name: "Tipo",
      selector: (row) => (
        <div>
          {!row.link ? "File audio e video" : "Link esterno"}
        </div>
      ),
      center: "true",
      width: "25%",
    },
    {
      name: "Azioni",
      width: "25%",
      center: "true",
      cell: (row) => (
        <>
          <Link to={`/admin/musicList/${row.slug}`}>
            <Button variant="link" className="text-primary">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-pencil-square me-1 text-primary"
                viewBox="0 0 16 16"
              >
                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                <path d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
              </svg>{" "}
            </Button>
          </Link>
          <Button
            variant="link"
            className="text-danger"
            onClick={() => deleteMusic(row.slug)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              className="bi bi-x-square ms-1 text-danger"
              viewBox="0 0 16 16"
            >
              <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
            </svg>
          </Button>
        </>
      ),
    },
  ];

  if (Loading) {
    return;
  }

  return <>
    <Container fluid className="p-0 m-0 text_data_admin px-2">
      <nav aria-label="breadcrumb ">
        <ol className="breadcrumb pb-5 ps-5">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Contenuti musicali
          </li>
        </ol>
      </nav>
    </Container>
    <Row>
      <Col lg="12" className="mb-5 pb-5">
        <div className="admin-card">
          <div className="admin-card-header">
            <div className="admin-card-icon black-gradient">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-music-note" viewBox="0 0 16 16">
                <path d="M9 13c0 1.105-1.12 2-2.5 2S4 14.105 4 13s1.12-2 2.5-2 2.5.895 2.5 2" />
                <path fill-rule="evenodd" d="M9 3v10H8V3z" />
                <path d="M8 2.82a1 1 0 0 1 .804-.98l3-.6A1 1 0 0 1 13 2.22V4L8 5z" />
              </svg>
            </div>
            <p><small>Contenuti musicali</small></p>
          </div>

          <div className=" mt-4 ms-3">
            <div className="w-100">
              <Link
                to="/admin/musicCreate"
                className="btn btn-black-gradient text-white"
                data-discover="true"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  fill="currentColor"
                  className="bi bi-plus"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                </svg>
                Inserisci contenuto musicale
              </Link>
            </div>
          </div>

          <div className="box_body_teams ps-3 py-4 text_size_data">
            <FloatingLabel
              controlId="floatingInput"
              label="Cerca una Musica"
              className="mb-0 w-100"
            >
              <FormControl
                type="text"
                placeholder=" Cerca pagina"
                className="mr-sm-2"
                value={searchTerm}
                onChange={handleSearchChange}
              />
            </FloatingLabel>


          </div>

          <DataTable
            columns={columns}
            data={filtredMusic}
            pagination
            paginationComponentOptions={paginationOptions}
            paginationPerPage={30}
          />
        </div>
      </Col>
    </Row>
  </>
};
export default MusicList;
